import { UserRoles } from '@modules/common/models/enums/UserRoles'
import { User } from '@modules/models'
import intersection from 'lodash/intersection'
import map from 'lodash/map'
import { storage } from './storageService'
import { VIPChannel } from '@modules/common/models/enums/VIPChannel'
import reduce from 'lodash/reduce'
import isEmpty from 'lodash/isEmpty'

export const hasUserRoles = (roles: UserRoles[], authorRoles?: string[]) => {
  const user = storage.getItem<User>('user')
  return !!intersection(authorRoles || map(user.roles, 'name'), roles).length
}

export const transformConfig = config => {
  return reduce(
    config,
    (result, value, key) => {
      const transformData = reduce(
        value,
        (inResult, inValue) => {
          if (isEmpty(inValue.ALLOWED_ROLES)) {
            inResult.push(inValue.TRANSITION_TO)
          } else if (hasUserRoles(inValue.ALLOWED_ROLES)) {
            inResult.push(inValue.TRANSITION_TO)
          }
          return inResult
        },
        []
      )
      if (transformData && transformData.length) {
        result[key] = transformData
      }
      return result
    },
    {}
  )
}

export const PERMISSION_MAP = [
  {
    id: VIPChannel.Wholesale,
    allowedRoles: [
      UserRoles.ADMINISTRATOR,
      UserRoles.CM_ADMIN,
      UserRoles.CENTRAL_MERCHANDISER_WHOLESALE
    ]
  },
  {
    id: VIPChannel.Retail,
    allowedRoles: [
      UserRoles.ADMINISTRATOR,
      UserRoles.CM_ADMIN,
      UserRoles.CENTRAL_MERCHANDISER_RETAIL
    ]
  }
]

export const ORDER_PERMISSION_MAP = [
  {
    id: VIPChannel.Wholesale,
    allowedRoles: [
      UserRoles.ADMINISTRATOR,
      UserRoles.CM_ADMIN,
      UserRoles.CENTRAL_MERCHANDISER_WHOLESALE,
      UserRoles.ZONE_AREA_MANAGER,
      UserRoles.EXTERNAL_CLIENT,
      UserRoles.WHOLESALE_SHOWROOM_ASSISTANT
    ]
  },
  {
    id: VIPChannel.Retail,
    allowedRoles: [
      UserRoles.ADMINISTRATOR,
      UserRoles.CM_ADMIN,
      UserRoles.CENTRAL_MERCHANDISER_RETAIL,
      UserRoles.REGIONAL_MERCHANDISER
    ]
  }
]

export const SAClientsAllowedRoles = [
  UserRoles.ADMINISTRATOR,
  UserRoles.CM_ADMIN,
  UserRoles.CENTRAL_MERCHANDISER_WHOLESALE,
  UserRoles.WHOLESALE_SHOWROOM_ASSISTANT,
  UserRoles.ZONE_AREA_MANAGER
]

export const SAZonesAllowedRoles = [
  UserRoles.ADMINISTRATOR,
  UserRoles.CM_ADMIN,
  UserRoles.CENTRAL_MERCHANDISER_RETAIL,
  UserRoles.REGIONAL_MERCHANDISER
]
